import { Component, Input, OnInit } from '@angular/core';

import { IColunaIcone } from '../../interface/icm-icone-generico';

@Component({
    selector: 'icm-coluna-icone',
    templateUrl: './view/icm-coluna-icone.component.html',
    styleUrls: ['./view/icm-coluna-icone.component.scss'],
})
export class IcmColunaIconeComponent implements OnInit {
    @Input() linha;
    @Input() coluna: IColunaIcone;
    @Input() carregando: boolean;

    icone: string;
    textoTooltip: string;
    cor: string = '#000000de';
    corDesabilitado: string = '#00000042';

    constructor() {}

    ngOnInit(): void {
        this.inicializarValores();
    }

    inicializarValores() {
        this.icone = this.coluna.valor(this.linha);
        this.textoTooltip = this.coluna.tooltip.valor(this.linha);
        if (this.coluna?.cor) this.cor = this.coluna.cor(this.linha);
    }
}
